import { COMPONENT_CONFIG, ContentBlock } from 'opensolar-pageeditor'

export const defaultExpoContents = (isPremium = false): ContentBlock[] => {
  let includedBlocks = Object.keys(COMPONENT_CONFIG)
  if (!isPremium) {
    //remove premium blocks
    includedBlocks = includedBlocks.filter((x) => {
      const value = COMPONENT_CONFIG[x]
      return x === 'cover' || !value.premium
    })
  }
  const enabledByDefault = ['navbar', 'our_story']
  return includedBlocks.map((block) => {
    let enabled = enabledByDefault.includes(block)
    if (block === 'cover') {
      enabled = isPremium
    }
    return {
      contentType: block,
      enabled,
    } as ContentBlock
  })
}
